
//function init() {
    $('a.show-more-link').on('click', function (e) {
        var extract = $(this).parent('.show-more-extract');
        var cntr = extract.parent('.show-more-cntr');
        var full = cntr.children('.show-more-full');

        extract.hide();
        full.slideToggle(333);
    });

    $('a.show-less-link').on('click', function (e) {
        var full = $(this).parent('.show-more-full');
        var cntr = full.parent('.show-more-cntr');
        var extract = cntr.children('.show-more-extract');

        full.slideToggle(333, function () {
            extract.show();
        });
    });
//}

//module.exports = init;